export interface Product {
  id: string;
  name: string;
  category: string;
  price: number;
  originalPrice?: number;
  image: string;
  badge?: string;
  rating: number;
  reviewCount: number;
  description: string;
  features: string[];
  isNew?: boolean;
  isHot?: boolean;
}

export const products: Product[] = [
  {
    id: 'p1',
    name: '丝柔玫瑰经典按摩精油',
    category: 'body-care',
    price: 298,
    originalPrice: 398,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20massage%20oil%20bottle%20with%20rose%20gold%20accents%20on%20a%20soft%20cream%20marble%20surface%2C%20warm%20ambient%20lighting%2C%20minimalist%20product%20photography%2C%20delicate%20rose%20petals%20scattered%20around%2C%20premium%20aesthetic%2C%20clean%20composition%2C%20soft%20shadows%2C%20high-end%20cosmetic%20style&width=800&height=800&seq=prod-body-oil-01&orientation=squarish',
    badge: '热卖',
    rating: 4.8,
    reviewCount: 1256,
    description: '精选天然植物精油，丝滑触感，温润滋养肌肤。适合情侣间的亲密按摩，营造浪漫氛围。',
    features: ['天然植物精华', '水溶性配方', '温感技术', '易清洗不留痕'],
    isHot: true,
  },
  {
    id: 'p2',
    name: '暗夜魅影真丝眼罩套装',
    category: 'accessories',
    price: 188,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20black%20silk%20sleep%20mask%20set%20with%20delicate%20lace%20trim%20on%20cream%20silk%20fabric%20background%2C%20elegant%20packaging%20box%20nearby%2C%20soft%20dramatic%20lighting%2C%20sensual%20boudoir%20aesthetic%2C%20premium%20product%20photography%2C%20rich%20textures%2C%20sophisticated%20composition&width=800&height=800&seq=prod-silk-mask-02&orientation=squarish',
    badge: '新品',
    rating: 4.6,
    reviewCount: 689,
    description: '100%桑蚕丝材质，轻薄透气，舒适遮光。搭配精致蕾丝边设计，兼具实用与美感。',
    features: ['100%桑蚕丝', '透气遮光', '可调节松紧', '精致礼盒装'],
    isNew: true,
  },
  {
    id: 'p3',
    name: '魅夜诱惑高级香薰蜡烛',
    category: 'body-care',
    price: 358,
    originalPrice: 458,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20black%20and%20gold%20luxury%20scented%20candle%20in%20a%20matte%20ceramic%20vessel%2C%20soft%20warm%20candlelight%20glow%2C%20on%20a%20dark%20marble%20surface%20with%20subtle%20reflections%2C%20atmospheric%20boudoir%20setting%2C%20premium%20home%20fragrance%20product%20photography%2C%20sensual%20moody%20lighting&width=800&height=800&seq=prod-candle-03&orientation=squarish',
    badge: '限定',
    rating: 4.9,
    reviewCount: 2103,
    description: '法国调香师精心调配，融合依兰、檀香与麝香，营造极致浪漫氛围。手工陶瓷容器，可持续燃烧60小时。',
    features: ['法国进口香料', '手工陶瓷杯', '燃烧60小时', '天然大豆蜡'],
    isHot: true,
  },
  {
    id: 'p4',
    name: '幻夜星辰情趣骰子游戏',
    category: 'games',
    price: 128,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20rose%20gold%20and%20black%20couples%20dice%20game%20set%20in%20a%20velvet%20lined%20box%2C%20on%20soft%20cream%20textured%20surface%2C%20subtle%20warm%20lighting%2C%20premium%20intimate%20product%20photography%2C%20sophisticated%20and%20tasteful%20composition%2C%20clean%20minimalist%20aesthetic&width=800&height=800&seq=prod-dice-04&orientation=squarish',
    rating: 4.5,
    reviewCount: 3456,
    description: '精致玫瑰金骰子，为情侣增添趣味互动。每面印有不同的亲密动作，让夜晚充满惊喜。',
    features: ['玫瑰金材质', '12面设计', '天鹅绒收纳盒', '情侣互动'],
  },
  {
    id: 'p5',
    name: '柔情蜜意情侣沐浴礼盒',
    category: 'body-care',
    price: 528,
    originalPrice: 698,
    image: 'https://readdy.ai/api/search-image?query=Premium%20luxury%20couples%20bath%20gift%20set%20with%20champagne%20gold%20bottles%20and%20rose%20petals%2C%20elegant%20white%20and%20gold%20packaging%2C%20on%20a%20marble%20bathroom%20surface%2C%20soft%20warm%20lighting%2C%20sensual%20spa%20aesthetic%2C%20high-end%20product%20photography&width=800&height=800&seq=prod-bath-set-05&orientation=squarish',
    badge: '礼盒',
    rating: 4.7,
    reviewCount: 892,
    description: '包含沐浴露、身体乳、按摩油和香薰蜡烛的奢华礼盒套装。精美礼盒包装，送礼自用两相宜。',
    features: ['四件套礼盒', '精美包装', '同香型搭配', '送礼首选'],
    isHot: true,
  },
  {
    id: 'p6',
    name: '极致丝滑水溶性润滑液',
    category: 'body-care',
    price: 168,
    originalPrice: 218,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20premium%20personal%20lubricant%20bottle%20in%20frosted%20glass%20with%20rose%20gold%20pump%2C%20on%20a%20soft%20cream%20surface%2C%20clean%20beauty%20product%20photography%2C%20soft%20diffused%20lighting%2C%20luxurious%20cosmetic%20aesthetic%2C%20tasteful%20composition&width=800&height=800&seq=prod-lube-06&orientation=squarish',
    rating: 4.8,
    reviewCount: 5678,
    description: '医用级水溶性配方，极致丝滑，温和不刺激。与安全套兼容，易清洗不残留。',
    features: ['医用级配方', '水溶性', 'pH平衡', '无色无味'],
  },
  {
    id: 'p7',
    name: '玫瑰之约真丝睡袍',
    category: 'accessories',
    price: 468,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20deep%20burgundy%20silk%20robe%20draped%20on%20a%20velvet%20hanger%2C%20delicate%20lace%20trim%20details%2C%20soft%20warm%20lighting%2C%20luxurious%20boudoir%20setting%2C%20premium%20lingerie%20product%20photography%2C%20rich%20textures%2C%20sophisticated%20sensual%20aesthetic&width=800&height=800&seq=prod-robe-07&orientation=squarish',
    badge: '爆款',
    rating: 4.9,
    reviewCount: 2341,
    description: '19姆米重磅桑蚕丝，垂坠感极佳。法式蕾丝镶边设计，优雅与性感兼具。',
    features: ['19姆米桑蚕丝', '法式蕾丝', '系带设计', '多色可选'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'p8',
    name: '魅惑之夜情调灯光套装',
    category: 'accessories',
    price: 258,
    originalPrice: 328,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20mood%20lighting%20set%20with%20warm%20amber%20LED%20candles%20and%20fairy%20string%20lights%20in%20a%20premium%20gift%20box%2C%20on%20a%20dark%20velvet%20surface%2C%20soft%20romantic%20glow%2C%20atmospheric%20bedroom%20setting%2C%20luxury%20product%20photography&width=800&height=800&seq=prod-light-08&orientation=squarish',
    rating: 4.4,
    reviewCount: 1567,
    description: '智能遥控氛围灯组，多色温可调。包含LED仿真蜡烛与星空投影灯，一键打造浪漫空间。',
    features: ['智能遥控', '多色温调节', '定时功能', 'USB充电'],
  },
  {
    id: 'p9',
    name: '秘蜜花园私密护理套装',
    category: 'body-care',
    price: 398,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20premium%20intimate%20care%20set%20in%20soft%20pastel%20packaging%20with%20rose%20gold%20details%2C%20on%20a%20cream%20marble%20surface%2C%20clean%20minimalist%20beauty%20product%20photography%2C%20soft%20natural%20lighting%2C%20sophisticated%20cosmetic%20aesthetic&width=800&height=800&seq=prod-care-set-09&orientation=squarish',
    badge: '医护推荐',
    rating: 4.7,
    reviewCount: 987,
    description: '专为女性设计的温和护理套装，包含清洁慕斯与保湿精华。pH弱酸性配方，呵护娇嫩肌肤。',
    features: ['弱酸配方', '无香精', '医用级标准', '温和清洁'],
  },
  {
    id: 'p10',
    name: '午夜巴黎情趣飞行棋毯',
    category: 'games',
    price: 198,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20couples%20board%20game%20mat%20in%20black%20and%20gold%20design%20rolled%20up%20with%20silk%20ribbon%2C%20on%20a%20cream%20textured%20surface%2C%20premium%20gift%20product%20photography%2C%20soft%20warm%20lighting%2C%20sophisticated%20intimate%20product&width=800&height=800&seq=prod-game-10&orientation=squarish',
    rating: 4.3,
    reviewCount: 4321,
    description: '法兰西风情主题情侣互动游戏毯，超大尺寸柔软面料。每一步都充满惊喜与浪漫。',
    features: ['超大尺寸', '柔软面料', '可机洗', '附赠收纳袋'],
  },
  {
    id: 'p11',
    name: '暗香浮动身体香膏',
    category: 'body-care',
    price: 228,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20matte%20black%20solid%20perfume%20balm%20tin%20with%20gold%20accents%2C%20on%20a%20cream%20marble%20surface%20with%20soft%20shadows%2C%20luxury%20fragrance%20product%20photography%2C%20minimalist%20composition%2C%20warm%20ambient%20lighting&width=800&height=800&seq=prod-perfume-11&orientation=squarish',
    badge: '新品',
    rating: 4.6,
    reviewCount: 543,
    description: '固体香膏设计，方便随身携带。融合玫瑰、琥珀与麝香调，持久留香8小时。',
    features: ['固体香膏', '持香8小时', '便携设计', '天然精油'],
    isNew: true,
  },
  {
    id: 'p12',
    name: '星月夜感官按摩仪',
    category: 'devices',
    price: 698,
    originalPrice: 898,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20sleek%20rose%20gold%20personal%20massager%20device%20on%20a%20soft%20cream%20surface%2C%20minimalist%20design%2C%20premium%20wellness%20product%20photography%2C%20soft%20diffused%20lighting%2C%20clean%20beauty%20tech%20aesthetic%2C%20sophisticated%20composition&width=800&height=800&seq=prod-massager-12&orientation=squarish',
    badge: '热卖',
    rating: 4.8,
    reviewCount: 3210,
    description: '采用声波脉冲技术，8种模式随心切换。医用硅胶材质，静音设计，IPX7级防水。',
    features: ['声波脉冲', '8种模式', '医用硅胶', 'IPX7防水'],
    isHot: true,
  },
];

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'body-care', name: '身体护理', icon: 'ri-heart-pulse-line' },
  { id: 'accessories', name: '情趣配饰', icon: 'ri-vip-diamond-line' },
  { id: 'games', name: '互动游戏', icon: 'ri-gamepad-line' },
  { id: 'devices', name: '智能设备', icon: 'ri-bluetooth-line' },
];